import { Plan, PlanLimits } from "../types";
import { getFeatureLimitOnPlan } from "../../featureAvailability";
import { Feature } from "../../featureAvailability";

export const DEFAULT_LIMITS: PlanLimits = {
    sources: 1000,
    transforms: 5000,
    collaborators: 3,
    projects: 10,
    variantsPerImage: 3,
    soft: false
};

/*
 - On UBP plans, the limits are "hard caps", which means they can't be exceeded even if they have credits available.
 - On non-UBP plans, limits are just limits. They don't have concepts of credits or hard caps.
 */

export const PLAN_LIMITS: Record<Plan, Partial<PlanLimits>> = {
    [Plan.Public]: {
        sources: 250000,
        transforms: 50000,
        collaborators: 2,
        projects: 10,
        variantsPerImage: getFeatureLimitOnPlan(Feature.AugmentationVariants, Plan.Public) || 3
    },
    [Plan.UbpBasic]: {
        sources: 10000000, // 10 million
        transforms: 200000000, // 200 million
        collaborators: 5,
        projects: 20,
        variantsPerImage: getFeatureLimitOnPlan(Feature.AugmentationVariants, Plan.UbpBasic) || 5
    },
    [Plan.UbpCore]: {
        sources: 10000000, // 10 million
        transforms: 200000000, // 200 million
        collaborators: 3,
        projects: 20,
        variantsPerImage: getFeatureLimitOnPlan(Feature.AugmentationVariants, Plan.UbpCore) || 5
    },
    [Plan.UbpGrowth]: {
        sources: 10000000, // 10 million
        transforms: 200000000, // 200 million
        collaborators: 15,
        projects: 50,
        variantsPerImage: getFeatureLimitOnPlan(Feature.AugmentationVariants, Plan.UbpGrowth) || 10
    },
    [Plan.UbpPremiumTrial]: {
        sources: 10000000, // 10 million
        transforms: 200000000, // 200 million
        collaborators: 20,
        projects: 50,
        variantsPerImage:
            getFeatureLimitOnPlan(Feature.AugmentationVariants, Plan.UbpPremiumTrial) || 10
    },
    [Plan.EnterpriseGrowth]: {
        sources: "Custom",
        transforms: "Custom",
        collaborators: "Custom",
        projects: "Custom",
        variantsPerImage:
            getFeatureLimitOnPlan(Feature.AugmentationVariants, Plan.EnterpriseGrowth) || 15
    },
    [Plan.Enterprise]: {
        sources: "Custom",
        transforms: "Custom",
        collaborators: "Custom",
        projects: "Custom",
        variantsPerImage: getFeatureLimitOnPlan(Feature.AugmentationVariants, Plan.Enterprise) || 15
    },
    [Plan.LegacySandbox]: {
        sources: 1000,
        transforms: 5000,
        collaborators: 3,
        projects: 3,
        variantsPerImage:
            getFeatureLimitOnPlan(Feature.AugmentationVariants, Plan.LegacySandbox) || 10
    },
    [Plan.LegacyStarter]: {
        sources: 10000,
        transforms: 200000,
        collaborators: 3,
        projects: 50,
        variantsPerImage:
            getFeatureLimitOnPlan(Feature.AugmentationVariants, Plan.LegacyStarter) || 10,
        labelers: 0,
        reviewers: 0
    },
    [Plan.Research]: {
        sources: 10000,
        transforms: 50000,
        collaborators: 15,
        projects: 20,
        variantsPerImage: getFeatureLimitOnPlan(Feature.AugmentationVariants, Plan.Research) || 5
    },
    [Plan.UninitalizedWorkspace]: { collaborators: 3, projects: 10, variantsPerImage: 3 }
} as any;

export const LIMITS_CONFIG: Record<Plan, PlanLimits> = Object.keys(PLAN_LIMITS).reduce(
    (acc, plan) => {
        acc[plan] = { ...DEFAULT_LIMITS, ...PLAN_LIMITS[plan] };
        return acc;
    },
    {} as Record<Plan, PlanLimits>
);
